/**
 * TGL (TijdGeld) Module Seeds - Consolidated Index
 *
 * Modular seed structure matching GET pattern.
 * Each family is stored in its own JSON file.
 *
 * Updated: Phase H-1 — standardized export shape to match GET/index.ts
 */

import tijdAnaloog from './TGL-TIJD-ANALOOG.json'
import tijdDigitaal from './TGL-TIJD-DIGITAAL.json'
import geldTerug from './TGL-GELD-TERUG.json'
import geldMaak from './TGL-GELD-MAAK.json'
import tijdAnaloogGedetailleerd from './TGL-TIJD-ANALOOG-GEDETAILLEERD.json'
import geldWissel from './TGL-GELD-WISSEL.json'
import tijdConversie from './TGL-TIJD-CONVERSIE.json'
import tijdDuur from './TGL-TIJD-DUUR.json'
import geldKoopjes from './TGL-GELD-KOOPJES.json'
import tijdPlanning from './TGL-TIJD-PLANNING.json'
import geldBudget from './TGL-GELD-BUDGET.json'
import geldKomma from './TGL-GELD-KOMMA.json'
import tijdSnelheid from './TGL-TIJD-SNELHEID.json'
import geldKorting from './TGL-GELD-KORTING.json'
import tijdSchema from './TGL-TIJD-SCHEMA.json'
import tijdKalender from './TGL-TIJD-KALENDER.json'
import tijdOmrekenen from './TGL-TIJD-OMREKENEN.json'
import geldBtw from './TGL-GELD-BTW.json'
import geldTerugrekenen from './TGL-GELD-TERUGREKENEN.json'
import tijdSamengesteld from './TGL-TIJD-SAMENGESTELD.json'
import TGL_GELD_TELLEN from './TGL-GELD-TELLEN.json'

const TGL_FAMILY_SEEDS = [
  { file: 'src/data/seeds/TGL/TGL-TIJD-ANALOOG.json', data: tijdAnaloog },
  { file: 'src/data/seeds/TGL/TGL-TIJD-DIGITAAL.json', data: tijdDigitaal },
  { file: 'src/data/seeds/TGL/TGL-GELD-TERUG.json', data: geldTerug },
  { file: 'src/data/seeds/TGL/TGL-GELD-MAAK.json', data: geldMaak },
  {
    file: 'src/data/seeds/TGL/TGL-TIJD-ANALOOG-GEDETAILLEERD.json',
    data: tijdAnaloogGedetailleerd,
  },
  { file: 'src/data/seeds/TGL/TGL-GELD-WISSEL.json', data: geldWissel },
  { file: 'src/data/seeds/TGL/TGL-TIJD-CONVERSIE.json', data: tijdConversie },
  { file: 'src/data/seeds/TGL/TGL-TIJD-DUUR.json', data: tijdDuur },
  { file: 'src/data/seeds/TGL/TGL-GELD-KOOPJES.json', data: geldKoopjes },
  { file: 'src/data/seeds/TGL/TGL-TIJD-PLANNING.json', data: tijdPlanning },
  { file: 'src/data/seeds/TGL/TGL-GELD-BUDGET.json', data: geldBudget },
  { file: 'src/data/seeds/TGL/TGL-GELD-KOMMA.json', data: geldKomma },
  { file: 'src/data/seeds/TGL/TGL-TIJD-SNELHEID.json', data: tijdSnelheid },
  { file: 'src/data/seeds/TGL/TGL-GELD-KORTING.json', data: geldKorting },
  { file: 'src/data/seeds/TGL/TGL-TIJD-SCHEMA.json', data: tijdSchema },
  { file: 'src/data/seeds/TGL/TGL-TIJD-KALENDER.json', data: tijdKalender },
  { file: 'src/data/seeds/TGL/TGL-TIJD-OMREKENEN.json', data: tijdOmrekenen },
  { file: 'src/data/seeds/TGL/TGL-GELD-BTW.json', data: geldBtw },
  {
    file: 'src/data/seeds/TGL/TGL-GELD-TERUGREKENEN.json',
    data: geldTerugrekenen,
  },
  // NEW — compound time calculation questions
  {
    file: 'src/data/seeds/TGL/TGL-TIJD-SAMENGESTELD.json',
    data: tijdSamengesteld,
  },
  // NEW — counting and recognizing money
  {
    file: 'src/data/seeds/TGL/TGL-GELD-TELLEN.json',
    data: TGL_GELD_TELLEN,
  },
] as const

const allQuestions = TGL_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question) => ({ ...question, __sourceFile: file })),
)

// Export consolidated seed collection (matches GET/index.ts pattern)
export default {
  module: 'TijdGeld',
  moduleCode: 'TGL',
  version: '8.0-modular',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
